import { type FormKitGroupValue } from "@formkit/core";
import type { AuditHistory, EntityWithAudits } from "@modernary/mui/components/audit";
import type { Lookup } from "@modernary/mui/components/lookup";
import { type PagingQuery } from "@modernary/mui/utils/api";
import type { EntityWithAuthRequestFields } from "@modernary/mui/utils/helpers";
import type { Inspection } from "../inspections/inspection";
import type { ConstructionProject } from "../constructionProject/constructionProject";
import type { StationarySource } from "../stationarySource/stationarySource";
import type { AsbestosFacility } from "../asbestosFacility/asbestosFacility";
import type { routeNames } from "@/routes";

export interface EnforcementAction extends EntityWithAudits, EntityWithAuthRequestFields {
  auditHistory: AuditHistory;
  href: string;
  id: number;
  inspectionId: number;
  inspection?: Inspection;
  inspectionCategory?: Lookup;
  inspectionCategoryMurn: string;
  constructionProjectId: number;
  constructionProject?: ConstructionProject;
  stationarySourceId: number;
  stationarySource?: StationarySource;
  asbestosFacilityId: number;
  asbestosFacility?: AsbestosFacility;
  number: string;
  type?: Lookup;
  typeMurn: string;
  sentDateTime: string;
  deliveryMethod?: Lookup;
  deliveryMethodMurn: string;
  complianceStatus?: Lookup;
  complianceStatusMurn: string;
  programType?: Lookup;
  programTypeMurn: string;
}

export interface EnforcementActionQuery extends PagingQuery {
  programTypeMurn: string;
  programTypeMurnIn: string[];
  inspectionId: number;
  inspectionCategoryMurn: string;
  constructionProjectId: number;
  stationarySourceId: number;
  asbestosFacilityId: number;
  typeMurnIn?: string[];
  complianceStatusMurnIn?: string[];
  sentDateTimeGreaterThanOrEqualTo: string;
  sentDateTimeLessThan: string;
  deliveryMethodMurnIn: string[];
  vacantLandParcelId: number;
  hasSearchOnParcels: boolean;
}

export interface EnforcementActionNew extends Partial<EnforcementAction> {}

export interface EnforcementActionFormKit extends EnforcementActionNew, FormKitGroupValue {}

export const stationarySourceEnforcementActionRouteName = "stationarySourceEnforcementAction" as const;
export const vacantLandEnforcementActionRouteName = "vacantLandEnforcementAction" as const;
export const asbestosEnforcementActionRouteName = "asbestosEnforcementAction" as const;
export const complaintEnforcementActionRouteName = "complaintEnforcementAction" as const;
export const dustEnforcementActionRouteName = "dustEnforcementAction" as const;

export type enforcementActionRoutes = keyof Pick<
  typeof routeNames,
  | typeof stationarySourceEnforcementActionRouteName
  | typeof vacantLandEnforcementActionRouteName
  | typeof vacantLandEnforcementActionRouteName
  | typeof vacantLandEnforcementActionRouteName
  | typeof vacantLandEnforcementActionRouteName
>;
